import React from 'react'

import { ZariContext } from '_zari/context'

import { Form, Button } from '_zari/core'

import { NuevoContactoModal } from 'sharedComponents/modals'

import * as SocioCrud from 'services/socio.service'

const ContactoSocioFormGroup = ({ disabled, showNewButton, idSocio, oneRowTrigger, onCreate, ...props }) => {
  const __zariContext = React.useContext(ZariContext)

  const [contactos, setContactos] = React.useState([])
  const [mostrarNuevoContactoModal, setMostrarNuevoContactoModal] = React.useState(false)

  React.useEffect(() => {
    if (idSocio) {
      SocioCrud.obtenerContactosxIdSocioAsSelect(idSocio)
        .then(({ data }) => {
          setContactos(data)
          if (data && data.length === 1) {
            oneRowTrigger(data[0])
          }
        })
        .catch(({ data: { error } }) => __zariContext.snack('error', error))
    }
  }, [idSocio, __zariContext, oneRowTrigger])

  const clickMostrarModal = React.useCallback(() => {
    setMostrarNuevoContactoModal(true)
  }, [])

  const innerOnCreate = React.useCallback(
    creationResult => {
      onCreate(
        creationResult,
        () => setMostrarNuevoContactoModal(false),
        () =>
          SocioCrud.obtenerContactosxIdSocioAsSelect(idSocio)
            .then(({ data }) => {
              setContactos(data)
            })
            .catch(({ data: { error } }) => __zariContext.snack('error', error))
      )
    },
    [onCreate, idSocio, __zariContext]
  )

  return (
    <>
      {showNewButton ? (
        <Form.InputGroup>
          <Form.Select {...props} disabled={disabled}>
            <option value=''>Seleccionar</option>
            {contactos.map((val, key) => (
              <option key={key} value={val._id}>
                {val.nombre}
              </option>
            ))}
          </Form.Select>
          <Form.InputGroup.Append>
            <Button disabled={disabled} onClick={clickMostrarModal}>
              &#x2b;
            </Button>
          </Form.InputGroup.Append>
        </Form.InputGroup>
      ) : (
        <></>
      )}
      {mostrarNuevoContactoModal && (
        <NuevoContactoModal
          handleClose={e => setMostrarNuevoContactoModal(false)}
          show={mostrarNuevoContactoModal}
          idSocio={idSocio}
          onCreate={innerOnCreate}
        />
      )}
    </>
  )
}

export default React.memo(ContactoSocioFormGroup)
